module.exports = __webpack_public_path__ + "img/potionIcon.19ae0c9d.png";